/** @jsxImportSource @emotion/react */
import { useNavigate } from "react-router-dom";
import { formatFecha, Titulo, TablaFiltrable } from "../../../shared";
import { Card } from "primereact/card";
import { Column } from "primereact/column";
import { Tag } from "primereact/tag";

export default function CardPropuestasSabana({ propuestas }) {
  const navigate = useNavigate();

  if (!propuestas || propuestas.length === 0) return null;

  return (
    <>
      <Titulo>Propuestas comerciales sábana</Titulo>
      <Card css={{ marginBottom: "1.5em" }}>
        <TablaFiltrable conFiltros={false}
          value={propuestas}
          dataKey="id"
          stripedRows
          emptyMessage="No hay propuestas sábana"
          onRowClick={(e) => navigate(`/propuestasabana/${e.data.id}`)}
          rowClassName={() => "cursor-pointer"}
          nombreArchivo="propuestas_sabana"
        >
          <Column header="Nombre" body={(p) => p.nombre || "-"} />
          <Column
            header="Fecha emisión"
            body={(p) => formatFecha(p.fechaEmision)}
            style={{ width: "10em" }}
          />
          <Column
            header="Estado"
            body={(p) =>
              !p.activa ? (
                <Tag value="Desactivada" severity="danger" />
              ) : p.fechaAceptacion ? (
                <Tag value="Aceptada" severity="success" />
              ) : p.fechaEmision ? (
                <Tag value="Emitida" severity="warning" />
              ) : (
                <Tag value="Pendiente" severity="info" />
              )
            }
            style={{ width: "9em", textAlign: "center" }}
          />
        </TablaFiltrable>
      </Card>
    </>
  );
}
